import React, { useContext } from "react";
import { useTheme } from "../../../contexts/Theme/ThemeContext";
import { ContainerPinterestTag } from "./styles";
import { Input } from "../../Input";
import { stringNumber } from "../../../services/Masks";
import { ConfiguracoesContext } from "../../../contexts/Configuracoes/ConfiguracoesContext";

export const PinterestTag: React.FC = () => {
  const { theme } = useTheme();
  const { configuracoes, setConfiguracoes } = useContext(ConfiguracoesContext);

  return (
    <ContainerPinterestTag theme={theme}>
      <div className="textoPinterest fonteTexto">
        Aqui você pode conectar seu catálogo ao Pinterest configurando o Pinterest Tag. <br />
        Essa integração é importante para anunciar com mais eficiência e acompanhar resultados das suas campanhas.<br /><br />
        <strong>A configuração é feita pelo time de especialistas do Conecta Venda de forma 100% gratuita — basta solicitar <a href="https://api.whatsapp.com/send/?phone=555434434563&text=Estou+no+painel+do+Conecta+Venda+e+quero+solicitar%20a%20configura%C3%A7%C3%A3o%20do%20Pinterest%20na%20minha%20conta" target="_blank" rel="noreferrer">clicando aqui.</a></strong>
      </div>
      <div className="box">
        <div className="input">
          <Input
            type="text"
            label="Verificação de Domínio"
            value={configuracoes.verificacoes_de_dominio?.pinterest || ""}
            maxLength={50}
            onChange={(newValue) => {
              setConfiguracoes({
                ...configuracoes,
                verificacoes_de_dominio: {
                  ...configuracoes.verificacoes_de_dominio,
                  pinterest: newValue,
                },
              });
            }}
            placeholder="abc123xyz..."
          />
        </div>
        <div className="texto-input fonteRotulos">
          Insira o content do código de verificação conforme destaque no exemplo:
          <br />
          {`<meta name="p:domain_verify" content="`}
          <strong>abc123xyz...</strong>
          {`" />`}
        </div>
        <div className="input">
          <Input
            type="text"
            label="ID do Pinterest Tag"
            value={configuracoes.dados_pinterest?.id || ""}
            maxLength={20}
            mask={{ mask: stringNumber }}
            onChange={(newValue) => {
              setConfiguracoes({
                ...configuracoes,
                dados_pinterest: {
                  ...configuracoes.dados_pinterest,
                  id: newValue,
                },
              });
            }}
            placeholder="Insira o ID do Pinterest Tag"
          />
        </div>
        <div className="input">
          <Input
            type="text"
            label="ID da Conta de Anúncios (Ad Account ID)"
            value={configuracoes.dados_pinterest?.ad_account_id || ""}
            maxLength={30}
            mask={{ mask: stringNumber }}
            onChange={(newValue) => {
              setConfiguracoes({
                ...configuracoes,
                dados_pinterest: {
                  ...configuracoes.dados_pinterest,
                  ad_account_id: newValue,
                },
              });
            }}
            placeholder="Insira o ID da conta de anúncios"
          />
        </div>
        <div className="input">
          <Input
            type="text"
            label="Access Token"
            value={configuracoes.dados_pinterest?.access_token || ""}
            onChange={(newValue) => {
              setConfiguracoes({
                ...configuracoes,
                dados_pinterest: {
                  ...configuracoes.dados_pinterest,
                  access_token: newValue,
                },
              });
            }}
            placeholder="Insira o Access Token do Pinterest"
          />
        </div>
      </div>
    </ContainerPinterestTag>
  );
};
